import { memo } from 'react';
import { Stack, SegmentedControl, Group, Grid, Text } from '@mantine/core';
import { IconDice, IconDeviceGamepad, IconRobot, IconTriangleFilled, IconDiamondFilled, IconCircleFilled, IconSquareFilled } from '@tabler/icons-react';
import AnswerButton from './AnswerButton';

/**
 * ControlPanel component provides the manual/automatic answer selection 
 * and the answer buttons grid.
 */
const ControlPanel = memo(({ 
    answerMode, 
    setAnswerMode, 
    handleCommand, 
    displayHistory, 
    colors 
}) => {
    const answerIcons = [IconTriangleFilled, IconDiamondFilled, IconCircleFilled, IconSquareFilled];
    
    return (
        <Stack gap="md">
            <SegmentedControl
                fullWidth
                value={answerMode}
                onChange={setAnswerMode}
                data={[
                    {
                        value: 'random',
                        label: (
                            <Group gap={8} justify="center" align="center" wrap="nowrap" style={{ pointerEvents: 'none' }}>
                                <IconDice size={18} />
                                <span>Random</span>
                            </Group>
                        )
                    },
                    {
                        value: 'own',
                        label: (
                            <Group gap={8} justify="center" align="center" wrap="nowrap" style={{ pointerEvents: 'none' }}>
                                <IconDeviceGamepad size={18} />
                                <span>Manual</span>
                            </Group>
                        )
                    }
                ]}
            />
            <Grid gutter="md">
                {[0, 1, 2, 3].map(i => (
                    <Grid.Col span={6} key={i}>
                        <AnswerButton 
                            onClick={() => handleCommand(i)} 
                            color={colors[i]}
                            icon={answerIcons[i]}
                            disabled={answerMode === 'random'} 
                        />
                    </Grid.Col>
                ))}
            </Grid>
            {answerMode === 'own' && (
                <Stack gap={4} align="center">
                    <Text size="xs" c="dimmed">Command History</Text>
                    <Group gap="xs" h={24}>
                        {displayHistory.length === 0 && <Text size="xs" c="dark.4">- No inputs yet -</Text>}
                        {displayHistory.map((idx, i) => {
                            const Icon = answerIcons[idx];
                            return <Icon key={i} size={16} color={colors[idx]} style={{ opacity: 1 - (i * 0.15) }} />;
                        })}
                    </Group>
                </Stack>
            )}
            {answerMode === 'random' && (
                <Text size="sm" c="dimmed" ta="center" mt="xs">
                    <IconRobot size={14} style={{ display: 'inline', marginRight: 5 }} />
                    Bots are answering automatically...
                </Text>
            )}
        </Stack>
    );
});

export default ControlPanel;
